export default __webpack_public_path__ + "56d38b742912089365d8b23a007e101f.gif";